export default __webpack_public_path__ + "static/media/no_message_blast.dda85b7d.svg";